import { useEffect, useRef } from "react";

export const SLEEP_PLAYLIST = "spotify:playlist:37i9dQZF1DWZd79rJ6a7lp";

const loadApi = (cb) => {
  if (window.SpotifyIframeAPI) return cb(window.SpotifyIframeAPI);
  const prev = window.onSpotifyIframeApiReady;
  window.onSpotifyIframeApiReady = (api) => {
    window.SpotifyIframeAPI = api;
    prev?.(api);
    cb(api);
  };
  if (!document.querySelector('script[src*="embed/iframe-api"]')) {
    const s = document.createElement("script");
    s.src = "https://open.spotify.com/embed/iframe-api/v1";
    s.async = true;
    document.head.appendChild(s);
  }
};

export const SpotifyPlayer = ({ controllerRef, initialUri, onPlayback, onReady }) => {
  const wrapRef = useRef(null);
  const uriRef = useRef(initialUri || SLEEP_PLAYLIST);

  useEffect(() => {
    let cancelled = false;
    const host = document.createElement("div");
    wrapRef.current.appendChild(host);
    loadApi((api) => {
      if (cancelled) return;
      api.createController(host, { width: "100%", height: 80, uri: uriRef.current }, (c) => {
        if (cancelled) return c.destroy?.();
        controllerRef.current = c;
        c.addListener("ready", () => onReady(true));
        c.addListener("playback_update", (e) => onPlayback(!e.data.isPaused, e.data.playingURI));
      });
    });
    return () => {
      cancelled = true;
      onReady(false);
      controllerRef.current?.destroy?.();
      controllerRef.current = null;
      if (wrapRef.current) wrapRef.current.innerHTML = "";
    };
  }, [controllerRef, onPlayback, onReady]);

  return <div ref={wrapRef} className="spotify-embed" data-testid="spotify-embed" />;
};
